

import Portfolio from './Home';

function App() {
  return (
    <Portfolio/>
  );
}

export default App;
